// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import power01Icon from "@/assets/icons/power-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Power01IconProps = Omit<IconProps, "name">;

export function Power01Icon(props: Power01IconProps): React.ReactNode {
  return <Icon name={power01Icon} {...props} />;
}
